module.exports = __webpack_public_path__ + "img/Postmodernisme_Demonstrasjon-mot-EEC.a0953267.jpg";